
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.36 3.293a1 1 0 01.187 1.157A7.45 7.45 0 0019.55 14.453a1 1 0 011.343 1.343 9.45 9.45 0 11-12.69-12.69 1 1 0 011.158.187zM6.823 6.67A7.45 7.45 0 0017.33 17.179 9.45 9.45 0 016.821 6.67z","fill":"#A6B7D4"}})])
          )
        }
      }
    